import { IconButton, useTheme } from '@mui/material'
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft'
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter'
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight'
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify'
import { Editor } from '@tiptap/core'

const TextAlign = ({ editor }: { editor: Editor }) => {
  const theme = useTheme()
  return (
    <>
      <IconButton
        title="left"
        onClick={() => editor.chain().focus().setTextAlign('left').run()}
        className={editor?.isActive({ textAlign: 'left' }) ? 'is-active' : ''}
        sx={{ borderRadius: 0 }}
      >
        <FormatAlignLeftIcon
          fontSize="small"
          sx={{
            color: editor?.isActive({ textAlign: 'left' }) ? theme.palette.text.highlight : theme.palette.text.primary,
          }}
        />
      </IconButton>
      <IconButton
        onClick={() => editor.chain().focus().setTextAlign('center').run()}
        className={editor?.isActive({ textAlign: 'center' }) ? 'is-active' : ''}
        sx={{ borderRadius: 0 }}
      >
        <FormatAlignCenterIcon
          fontSize="small"
          sx={{
            color: editor?.isActive({ textAlign: 'center' })
              ? theme.palette.text.highlight
              : theme.palette.text.primary,
          }}
        />
      </IconButton>
      <IconButton
        onClick={() => editor.chain().focus().setTextAlign('right').run()}
        className={editor?.isActive({ textAlign: 'right' }) ? 'is-active' : ''}
        sx={{ borderRadius: 0 }}
      >
        <FormatAlignRightIcon
          fontSize="small"
          sx={{
            color: editor?.isActive({ textAlign: 'right' }) ? theme.palette.text.highlight : theme.palette.text.primary,
          }}
        />
      </IconButton>
      <IconButton
        onClick={() => editor.chain().focus().setTextAlign('justify').run()}
        className={editor?.isActive({ textAlign: 'justify' }) ? 'is-active' : ''}
        sx={{ borderRadius: 0 }}
      >
        <FormatAlignJustifyIcon
          fontSize="small"
          sx={{
            color: editor?.isActive({ textAlign: 'justify' })
              ? theme.palette.text.highlight
              : theme.palette.text.primary,
          }}
        />
      </IconButton>
    </>
  )
}
export default TextAlign
